import { render, staticRenderFns } from "./VCompanyDocumentsBrowse.vue?vue&type=template&id=7e2dd5e2&lang=pug"
import script from "./VCompanyDocumentsBrowse.vue?vue&type=script&lang=ts"
export * from "./VCompanyDocumentsBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports